const searchForm = {
	$this: $('.js-search-container'),
	$btn: $('.js-search-btn'),
	$close: $('.js-close-search'),
	$inner: $('.js-search-container > .inner'),
};

function checkLength( e, submit ) {
	var val = $('.js-search-container .input[type="text"]').val();
	$( '.js-search-container .fake-input > span').html(val);
	var w = $('.js-search-container .fake-input > span').outerWidth(true);
	$('.js-search-container .stroke .inner').css({'width' : w});
}

searchForm.init = function () {

	searchForm.$btn.on('click', function (e) {
		e.preventDefault();
		$(this).addClass('is-hidden');
		setTimeout(function () {
			searchForm.$close.addClass('is-shown');
			searchForm.$this.find('.input').focus();
		}, 300);
		if (Modernizr.mq('(min-width: 768px)')) { // tablet portrait and bigger:
			// change width:
			var w = $('.js-header > .center').width() - ($('.js-header .menu-items').outerWidth(true)) - $('.js-header .logo').outerWidth(true);
			searchForm.$inner.css('width', w);
			searchForm.$this.css('width', w);

		} else { // mobile:
			// fadeIn:
			searchForm.$this.css('visibility', 'visible');
			setTimeout(function () {
				searchForm.$this.addClass('is-active');
			}, 100);
		}

	});

	searchForm.$close.on('click', function (e) {
		e.preventDefault();
		$(this).removeClass('is-shown');
		searchForm.$btn.removeClass('is-hidden');
		if (Modernizr.mq('(min-width: 768px)')) { // tablet portrait and bigger:
			searchForm.$this.removeClass('is-active').css('width', 0);
		} else { // mobile
			searchForm.$this.removeClass('is-active').removeAttr('style');
		}
	})

	$('.js-search-container .input[type="text"]').keypress(function (e) {
		checkLength( e, false );
	});

	$( '.js-search-container .input[type="text"]' ).keyup(function( e ) {
		checkLength( e, true );
	});

};

export { searchForm };
